/**
 * API client for the checklist coverage report (`crm-calls/coverage.routes.ts`).
 *
 * Its own file rather than more of `calls.ts` for the same reason `callPilot.ts`
 * is: that one is the log, the dialer, the settings and the recordings, and this
 * is a report - one read, no writes, and nothing on this screen edits a call.
 */
import { api } from "./api";

export interface CoverageQuestion {
  id: string;
  question: string;
  /** Scored calls in the period that covered this point. */
  covered: number;
}

export interface CoverageOperator {
  userId: string;
  /** Null on the unclaimed inbound bucket, which has no operator to name. */
  name: string | null;
  reads: number;
  /** Covered count per checklist id. An absent id is zero. */
  covered: Record<string, number>;
}

export interface CoverageReport {
  from: string;
  to: string;
  /**
   * The period held more scored calls than one report may read, so the OLDEST
   * of them are missing. Said out loud on the screen: a coverage table that
   * quietly dropped a third of the period is a number nobody can tell is wrong.
   */
  truncated: boolean;
  /** Scored calls in the period. The denominator for every number here. */
  reads: number;
  questions: CoverageQuestion[];
  operators: CoverageOperator[];
}

export function getCallCoverage(from: Date, to: Date): Promise<CoverageReport> {
  const q = new URLSearchParams({ from: from.toISOString(), to: to.toISOString() });
  return api.get(`/admin/crm/calls/coverage?${q.toString()}`);
}
